// extracted by mini-css-extract-plugin
export default {"svg":"styles_svg__jwhPn","image":"styles_image__ajoE-","hidden":"styles_hidden__6Wo47","placeholder":"styles_placeholder__CxlVA","container":"styles_container__fVVIO"};